import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 px-5 pb-32 pt-12 text-center text-white/65" data-id="element-126" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl" data-id="element-127" data-mp="206rfr8n93coj">
        <p className="font-display text-xl font-black text-white" data-id="element-128" data-mp="209x42lo22aj7">Hernia Clinical Playbook™</p>
        <p className="mt-2 text-sm" data-id="element-129" data-mp="2f2h7lnf4ak16">© 2026 · Dr. Ryan Carter – Hernia Clinical Playbook™. All Rights Reserved.</p>
        <div className="mt-8 rounded-2xl bg-white/[0.05] p-5 text-left text-xs leading-relaxed ring-1 ring-white/10" data-id="element-130" data-mp="1mg5x9l1pl4r6">
          <p className="font-extrabold uppercase tracking-wider text-white/85" data-id="element-131" data-mp="1hhl4g6osdncr">Important disclaimer</p>
          <p className="mt-2" data-id="element-132" data-mp="1w67kkam8mj51">
            This material is intended for educational and professional support purposes only. It does not constitute
            medical diagnosis, individualized medical advice, treatment prescription, or a guarantee of clinical
            outcomes.
          </p>
          <p className="mt-2" data-id="element-133" data-mp="yr3do7nil1u1">
            Physical therapists should apply their own professional judgment, follow applicable clinical guidelines and
            regulations, and refer patients when clinically appropriate.
          </p>
        </div>
      </div>
    </footer>;
}